import { useRef, useMemo } from 'react';
import { motion, useInView } from 'framer-motion';

const partners = [
  { name: 'Dharma Productions', logo: '/logos/dharma.png' },
  { name: 'Yash Raj Films', logo: '/logos/yrf.png' },
  { name: 'Excel Entertainment', logo: '/logos/excel.png' },
  { name: 'Phantom Films', logo: '/logos/phantom.png' },
  { name: 'TVF', logo: '/logos/tvf.png' },
  { name: 'Sikhya Entertainment', logo: '/logos/sikhya.png' },
  { name: 'FTII', logo: '/logos/ftii.png' },
  { name: 'CBFC', logo: '/logos/cbfc.png' },
  { name: 'NSD', logo: '/logos/nsd.png' },
  { name: 'SNA', logo: '/logos/sna.png' },
  { name: 'LKA', logo: '/logos/lka.png' },
];

// Fisher-Yates shuffle
const shuffle = (arr) => {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
};

const InstitutionalPartnersSection = () => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-80px' });

  // Randomize once per mount, then double for seamless loop
  const shuffled = useMemo(() => shuffle(partners), []);
  const doubled = [...shuffled, ...shuffled];

  return (
    <section ref={ref} className="py-16 sm:py-24 px-6 md:px-12 border-t border-[#0F1B2D]/5 overflow-hidden" data-testid="partners-section">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <p className="text-[10px] uppercase tracking-[0.3em] text-[#C4A35A] font-bold mb-3">
            Institutional & Production Partners
          </p>
          <h2 className="font-['Playfair_Display'] text-2xl sm:text-3xl font-semibold text-[#0F1B2D]">
            Trusted by India's Leading Studios & Institutions
          </h2>
        </motion.div>

        {/* Marquee slider — no gradient edges */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="relative overflow-hidden"
        >
          <div className="marquee-track flex items-center gap-20">
            {doubled.map((p, i) => (
              <div
                key={`${p.name}-${i}`}
                className="flex-shrink-0 flex items-center justify-center h-16"
                data-testid={i < partners.length ? `partner-${p.name.toLowerCase().replace(/\s+/g, '-')}` : undefined}
              >
                <img
                  src={p.logo}
                  alt={p.name}
                  className="h-12 w-auto object-contain grayscale opacity-30 hover:opacity-60 transition-opacity duration-500"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </motion.div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.5, delay: 0.8 }}
          className="text-center text-[10px] text-[#9B9589] font-medium mt-10 uppercase tracking-wider"
        >
          Partnerships for verification, accreditation, IP protection, financial aid, and production oversight
        </motion.p>
      </div>
    </section>
  );
};

export default InstitutionalPartnersSection;
